export default "/images/f306ff8b48b5ef11e5a63685def0f56a.avif";